import Dashboard from '../containers/dashboard'
import DocumentDetailsManagement from '../containers/document-details-management'

const DocumentDetails = () => {
  return (
    <Dashboard>
      <DocumentDetailsManagement />
    </Dashboard>
  )
}

export default DocumentDetails
